import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ListAttiProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (item?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label: string;
  idDominio: string;
  betweenFrom?: number;
  betweenTo?: number;
}

const ListAttiComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label,
  idDominio,
  betweenFrom,
  betweenTo,
}: ListAttiProps): React.ReactElement => {
  const [states] = useHttpFetch<HttpResponse<Array<ValoreDominioVO>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/valori-dominio-atti/id-dominio/${idDominio}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) => {
        let castedResponse = (response.data.payload || []) as Array<ValoreDominioVO>;

        if (betweenFrom && betweenTo) {
          castedResponse = castedResponse.filter(
            (item) =>
              Number.parseInt(item.key?.idValore || '', 10) >= betweenFrom &&
              Number.parseInt(item.key?.idValore || '', 10) <= betweenTo
          );
        }

        return castedResponse.map((item) => ({
          id: item.key?.idValore,
          value: item.descrizioneBreveValore,
        })) as Array<ItemVM>;
      },
    }
  );

  const statesData: Array<ItemVM> = (states.data || []) as Array<ItemVM>;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${label}-id`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${label}-id`}
        id={`${label}-id`}
        name={`${label}-name`}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => onChange(statesData?.find((item) => item.id === event.target.value))}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {statesData?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListAttiComponent.displayName = 'List Atti component';

const ListAtti = memo(ListAttiComponent);

export default ListAtti as typeof ListAttiComponent;
